export class CarnetQueryRequest {
  body: CarnetQueryBody = new CarnetQueryBody();
}

export class CarnetQueryBody {
  ProcessName: string = "DC Community Portal SR Process Wrapper WF";
  DCMethod: string = "QUERY";
  DCLoginName: string = "";
  DCLanguage: string = "ENU";
  DCIncomingHierarchy: CarnetQueryDCIncomingHierarchy = new CarnetQueryDCIncomingHierarchy();
}

export class CarnetQueryDCIncomingHierarchy {
  MessageId: string = "";
  IntObjectName: string = "DC Community Portal SR IO";
  MessageType: string = "Integration Object";
  IntObjectFormat: string = "Siebel Hierarchical";
  "ListOfDC Community Portal SR IO": ListOfDCCommunityPortalSRIO =
    new ListOfDCCommunityPortalSRIO();
}

export class ListOfDCCommunityPortalSRIO {
  "DC Community Portal SR": DCCommunityPortalSRQuery = new DCCommunityPortalSRQuery();
}

export class DCCommunityPortalSRQuery {
  "SR Number": string = "";
  "SR Type": string = "";
  "Sub Type": string = "";
  CSN: string = "";
}
